import { option } from "fp-ts";
import { ComponentProps, forwardRef } from "react";
import { Option } from "fp-ts/Option";
import {
  FieldProps,
  LocalizedString,
  TextChildren,
} from "@dbn/omnichannel-design-system-g4p";
import { useFormatCurrency } from "../../../intl";
import { Currency, Positive } from "../../../globalDomain";
import { NumberField } from "../../NumberField/NumberField";

type Props = FieldProps<Option<number>> & {
  id?: string;
  description?: LocalizedString;
  placeholder: LocalizedString;
  autoFocus?: boolean;
  min?: number;
  max?: number;
  step?: Positive;
  currency: Currency;
  cta?: ComponentProps<typeof NumberField>["cta"];
  assistiveText?: TextChildren;
  decimalDigits?: number;
};

export const MoneyField = forwardRef<HTMLInputElement, Props>(
  (props, forwardedRef) => {
    const formatCurrency = useFormatCurrency();
    const decimalDigits =
      props.decimalDigits !== undefined ? props.decimalDigits : 3;

    return (
      <NumberField
        {...props}
        locale="sk"
        ref={forwardedRef}
        rightContent={option.some(formatCurrency(props.currency))}
        assistiveText={props.assistiveText}
        formatOptions={{ maximumFractionDigits: decimalDigits }}
      />
    );
  }
);
